/*** IMPORTS FROM imports-loader ***/
import hydrator from "@gjensidige/views-api/src/runtime/hydrator";
import Component from ".";

/* global hydrator, Component */

// create a map of what we have hydrated, share it on window
window.__HYDRATED__ = window.__HYDRATED__ || {};

// get the current script executing
const partSrc = window.document?.currentScript?.getAttribute('src');

// filter the ones that need to be hydrated (data-nodeid contains the id for the props -> only hydration on node id's)
const parts = Array.from(
  document.querySelectorAll('script[src="' + partSrc + '"]')
).filter((part) => part.getAttribute('data-nodeid'));

// if this selection of parts contains elements that needs to be hydrated, add an eventListener
if (parts.length && window.addEventListener) {
  window.addEventListener('load', function () {
    parts.forEach((part) => {
      // make sure we only hydrate our components once
      const NODE_ID = part.getAttribute('data-nodeid');
      if (!window.__HYDRATED__[NODE_ID]) {
        window.__HYDRATED__[NODE_ID] = true;
        hydrator(Component, NODE_ID);
      }
    });
  });
}


import '@gjensidige/core-typography/lib-css/index.css';
import '@gjensidige/core-grid/lib-css/index.css';

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types/prop-types';
import { Col } from '@gjensidige/core-grid/lib-css/col';
import { Container } from '@gjensidige/core-grid/lib-css/container';
import { Row } from '@gjensidige/core-grid/lib-css/row';
import { Title } from '@gjensidige/core-typography/lib-css/title';
import utils from '@gjensidige/core-utilities-css';

import FaqGroupWrapper from './faq-group-wrapper';
import { FaqPartProps as Props } from './types';

import styles from '../less/faq.module.less';
export const Faq = ({
  title,
  groups,
  hideGroupLabel = false,
  hideIllustration = false
}: Props) => {
  return (
    <Container
      className={classNames(styles.overrides, utils['my-6'], utils['my-md-9'])}
    >
      {!hideIllustration && (
        <Row
          className={classNames(
            utils['pb-4'],
            utils['pb-md-5'],
            utils['text-center']
          )}
        >
          <Col
            xxs={{ offset: 2, span: 8 }}
            xs={{ offset: 3, span: 6 }}
            sm={{ offset: 4, span: 4 }}
            lg={{ offset: 5, span: 2 }}
          >
            <div
              className={classNames(styles.illustrationWrapper)}
              data-testid="illustration"
            ></div>
          </Col>
        </Row>
      )}
      {title && (
        <Row
          className={classNames(
            utils['pb-4'],
            utils['pb-md-5'],
            utils['text-center']
          )}
        >
          <Col lg={{ offset: 3, span: 6 }}>
            <Title
              tag="h2"
              className={styles.titleMargin}
              data-testid="faq-title"
            >
              {title}
            </Title>
          </Col>
        </Row>
      )}
      <Row>
        {groups?.length > 0 &&
          (groups.length === 1 ? (
            <Col md={{ offset: 2, span: 8 }} lg={{ offset: 3, span: 6 }}>
              <FaqGroupWrapper
                group={groups[0].group}
                label={groups[0].label}
                hideGroupLabel={hideGroupLabel}
                noTitle={!title}
              />
            </Col>
          ) : (
            <Col md={{ offset: 1, span: 10 }}>
              <Row
                className={classNames(
                  utils['d-flex'],
                  utils['justify-content-center']
                )}
              >
                {groups.map((groupItem, index) => (
                  <Col
                    key={`${groupItem.group.label}_${index}`}
                    xxs={12}
                    md={6}
                    className={classNames({
                      [utils['mt-8']]: index > 0,
                      [utils['mt-md-0']]: index === 1
                    })}
                  >
                    <FaqGroupWrapper
                      group={groupItem.group}
                      label={groupItem.label}
                      hideGroupLabel={false}
                      noTitle={!title}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          ))}
      </Row>
      <div className={utils['mt-8']}></div>
    </Container>
  );
};

Faq.propTypes = {
  title: PropTypes.string,
  groups: PropTypes.array.isRequired,
  hideGroupLabel: PropTypes.bool,
  hideIllustration: PropTypes.bool
};

Faq.CSR = true;

export default Faq;
